import { createGlobalStyle } from 'styled-components';
import OmoriFont from './fonts/OMORI_GAME.ttf';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'OMORI_GAME';
    src: url(${OmoriFont}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  /* Fallback font stack in case OMORI font fails to load */
  * {
    font-family: 'OMORI_GAME', 'Courier New', monospace;
  }

  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
`;

export default GlobalStyles;